import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Button, FormControl, Table } from "react-bootstrap";
import { LuPenLine, LuDownload, LuArrowDownToLine, LuPlus, LuMail } from "react-icons/lu";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import CommonPagination from '../utils/CommonPagination';
import API from "../../services/axiosInstance"
import Pagination from '../common_modules/pagination';
import FilterBar from '../common_modules/filter';
import { FormLoader, useFormLoader } from "../common_modules/loader";
import Permission from '../security/permission';
import { AUTH_CODE } from '../security/authCodes';
import usePreventMultiClick from '../utils/SubmitPrevent';
import { SearchIcon } from '../common_modules/commonIcons';

const InvoiceList = () => {
    const [invoiceList, setInvoiceList] = useState([]);
    const [publisherName, setPublisherName] = useState("");

    // pagination & filter state
    const [paginationData, setPaginationData] = useState({});
    const [searchConfig, setSearchConfig] = useState({});

    const location = useParams();
    const accGuid = location?.guid;
    const accId = location?.id;
    const invId = location?.invId;

    const navigate = useNavigate();

    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook loader
    // Preevnt Multiple Clicks
    const { btnClicked, setBtnClicked } = usePreventMultiClick();

    const tableFields = [
        { label: "Id", value: "id", enableSorting: true, enableTableHeader: false, enableIcon: true },
        { label: "Invoice Series", value: "invoice_series", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Invoice Month", value: "invoice_month", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Invoice Year", value: "invoiceYear", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Payment Date", value: "paymentDate", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Payment Amount", value: "paymentAmount", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Description", value: "description", enableSorting: false, enableTableHeader: true, enableIcon: true },
        { label: "Approve Status", value: "approveStatus", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Invoice File", value: "invoiceFile", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Status", value: "status", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Created On", value: "accId", enableSorting: false, enableTableHeader: true, enableIcon: false },
        { label: "Updated On", value: "accId", enableSorting: false, enableTableHeader: true, enableIcon: false },
    ];

    const manageInvoiceList = async (search, page, field = tableFields[0].value, order = "asc") => {
        startLoading();
        try {
            const size = 10;
            // is finance = 1 in case of finance invoice
            // const invoiceList = await API.get(`/publisher/invoice/${accId}/${accGuid}/list/1?page=${page}&size=${size}`);
            // const invoiceList = await API.get(`/publisher/invoice/${accId}/${accGuid}/list/1?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);
            const res = await API.get(`/publisher/invoice/${accId}/${accGuid}/fin/list?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);
            // const data = invoiceList?.data;
            // if (data?.content) {
            //     setInvoiceList(data?.content);
            //     setPaginationData(data);
            // }

            const data = res?.data?.data?.content;
            setPublisherName(res?.data?.name);
            if (res.status === 200 && data) {
                setInvoiceList(data);
                // save pagination information
                let pagination = res.data.data;
                delete pagination.content; //  remove data
                setPaginationData(pagination);
            } else {
                setInvoiceList([]);
                setPaginationData({});
            }
        } catch (error) { }
        finally {
            stopLoading();
        }
    }

    const nextPage = (nextPage) => {
        manageInvoiceList("", nextPage, searchConfig?.orderField, searchConfig?.orderDir)
    }


    const onChangeSearch = (params) => {
        setSearchConfig(params)
        manageInvoiceList(params.keyword, 0, params.orderField, params.orderDir); // API call
    }

    // download invoice 
    // const monthMap = {
    //     January: 1,
    //     February: 2,
    //     March: 3,
    //     April: 4,
    //     May: 5,
    //     June: 6,
    //     July: 7,
    //     August: 8,
    //     September: 9,
    //     October: 10,
    //     November: 11,
    //     December: 12,
    // };

    // const downloadInvoice = (file, monthName, year) => {

    //     const BASE_URL = "https://1437953666.rsc.cdn77.org/publisher-test/invoice-files";

    //     const monthNum = monthMap[monthName];
    //     const folderName = `${monthNum}_${year}`;
    //     // const fileName = item.invoiceFile;
    //     const fileUrl = `${BASE_URL}/${folderName}/${file}`;

    //     const a = document.createElement("a");
    //     a.href = fileUrl;
    //     a.download = file;
    //     a.target = "_blank";
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);
    // }

    // common function for downlaod any file
    const downloadFileFn = (filePath, blobData) => {
        const fileName = filePath?.split("/").pop();

        const url = window.URL.createObjectURL(new Blob([blobData]));

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        a.remove();
        window.URL.revokeObjectURL(url);
        alert("File downloaded successfully!!");
    };

    const downloadInvoice = async (invoiceFile, invoiceMonth, invoiceYear) => {
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const response = await API.post('/publisher/invoice/download/file',
                {
                    fileName: invoiceFile,
                    invoiceMonth: invoiceMonth,
                    invoiceYear: invoiceYear,
                },
                { responseType: "blob" }
            );
            downloadFileFn(invoiceFile, response.data);
        } catch (error) {
            console.error("Download Failed:", error);
            alert("Unable to download file");
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    }

    // payment advice
    // const downloadPaymentAdvice = async (id, accountGuid, filePath)=>{
    //     await API.post(`/publisher/invoice/paymentAdvice/download`,{
    //         id:id,
    //         accountGuid:accountGuid,
    //         filePath:filePath,
    //     });
    // }

    // Downlaod payment advice
    const downloadPaymentAdvice = async (id, accountGuid, filePath) => {
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const response = await API.post('/publisher/invoice/paymentAdvice/download',
                { id, accountGuid, filePath },
                { responseType: "blob" }
            );
            downloadFileFn(filePath, response.data);
        } catch (error) {
            console.error("Download Failed:", error);
            alert("Unable to download file!");
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    }

    const sendReminder = async (id) => {
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const res = await API.get(`/publisher/invoice/send/reminder/${id}/${accGuid}`);
            if (res?.data?.status === "Success") {
                alert("Reminder send successfully !!")
            } else {
                alert("Reminder failed");
            }
        } catch (error) {
            console.log(error)
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    }

    const createInvoice = () => {
        if (invoiceList[0]?.invSettingStatus == 5) {
            alert("Invoice setting is not approved");
            return;
        }
        navigate(`/add-invoice/${accId}/${accGuid}`)
    }

    // Coverred date in to readble format
    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();

        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        const seconds = String(date.getUTCSeconds()).padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    useEffect(() => {
        if (accGuid) {
            manageInvoiceList("", 0);
        }
    }, [accGuid]);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                {/* <span>{publisherName}</span> */}
                <Link to={`/publisher/info/${accId}/${accGuid}`}><span>{publisherName}</span></Link>
                <span>Manage Publisher Invoice</span>
                {/* <span>{accId}</span> */}
            </div>
            <h6 className="title mb-4 mt-4">Publisher's Invoice Listing</h6>
            <Card className='p-2'>
                <div className="filter row">
                    <Permission code={AUTH_CODE.financeInvoice.createInvoice}>
                        {
                            // invoiceList[0]?.invSettingStatus !== 5 && (
                            // <Link to={`/add-invoice/${accId}/${accGuid}`} style={{ color: "#ffffff" }}>
                            // <Link>
                            <Button variant="primary" className='addBtn' onClick={() => createInvoice()} style={{ width: "max-content" }}>
                                Create Invoice  <LuPlus />
                            </Button>
                            // </Link>
                            // )
                        }

                    </Permission>
                    <FilterBar defaultOrder={"asc"} defaultField={tableFields[0].value} fields={tableFields} onSearch={onChangeSearch} />
                </div>
                <div className="mt-0 table-wrapper mt-3">
                    {/* <div className="table-scroll"> */}
                    <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                        <thead>
                            <tr>
                                {/* <th>Invoice Series</th>
                                <th>Invoice Month</th>
                                <th>Invoice Year</th>
                                <th>Payment Date</th>
                                <th>Payment Amount</th>
                                <th>Description</th>
                                <th>Approve Status</th>
                                <th>Invoice File</th>
                                <th>Status</th>
                                <th>Created On</th>
                                <th>Updated On</th>
                                <th>Action</th> */}
                                <th>☰</th>
                                {
                                    tableFields?.map((item, i) => {
                                        if (!item.enableTableHeader) {
                                            return false;
                                        }
                                        return (
                                            <th key={i}>
                                                {item.label}
                                                {item.enableIcon ? <SearchIcon className="ms-1" size={10} fill="white" /> : ""}
                                            </th>
                                        )
                                    })
                                }
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                invoiceList.length > 0 ?
                                    invoiceList?.map((invList, index) => (
                                        <tr key={index}>
                                            <td>{(paginationData.number * paginationData.size) + (index + 1)}</td>
                                            {/* <td>{invList.id}</td> */}
                                            <td>{invList?.invoiceSeries}</td>
                                            <td>{invList?.invoiceMonth}</td>
                                            <td>{invList?.invoiceYear}</td>
                                            <td>{invList?.paymentDate?.split("T")[0]}</td>
                                            <td>{invList?.paymentAmount}</td>
                                            <td>{invList?.description}</td>
                                            <td>{invList?.approveStatus}</td>
                                            <td>{invList?.finalStatus === 1 ? "-" : invList?.invoiceFile}</td>
                                            <td>{invList?.status}</td>
                                            <td>{formatDateTime(invList?.createdAt)}</td>
                                            <td>{formatDateTime(invList?.updatedAt)}</td>
                                            <td>
                                                <div className="d-flex gap-2 flex-nowrap activePubAllBtns justify-content-center">
                                                    <Permission code={AUTH_CODE.financeInvoice.editUpdateInvoice}>
                                                        {[0, 1, 2, 3, 4, 5, 6].includes(invList?.finalStatus) ? (
                                                            <Link to={`/update-invoice/${invList?.id}/${accId}/${accGuid}`} state={{
                                                                invoiceId: invList?.id, publisherName: publisherName
                                                            }}><button><LuPenLine /> Edit </button></Link>
                                                        ) : ''}
                                                    </Permission>
                                                    <Permission code={AUTH_CODE.financeInvoice.downloadInvoice}>
                                                        {[2, 3, 4, 5, 6].includes(invList?.finalStatus) ? (
                                                            <button disabled={btnClicked} onClick={() => downloadInvoice(invList?.invoiceFile, invList?.invoiceMonth, invList?.invoiceYear)}><LuDownload /> Download invoice</button>
                                                        ) : ''}
                                                    </Permission>
                                                    <Permission code={AUTH_CODE.financeInvoice.downloadPaymentAdvice}>
                                                        {[6].includes(invList?.finalStatus) && (invList?.filePath) ? (
                                                            <button disabled={btnClicked} onClick={() => downloadPaymentAdvice(invList?.id, invList?.accountGuid, invList?.filePath)}><LuArrowDownToLine /> Download Payment Advice </button>
                                                        ) : ''}
                                                    </Permission>
                                                    <Permission code={AUTH_CODE.financeInvoice.sendReminder}>
                                                        {[0, 1].includes(invList?.finalStatus) ? (
                                                            <button disabled={btnClicked} onClick={() => sendReminder(invList?.id)}><LuMail /> Send Reminder </button>
                                                        ) : ''}
                                                    </Permission>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : <tr><td colSpan={13}>No Data Available</td></tr>
                            }
                        </tbody>
                    </Table>
                    {/* </div> */}
                </div>
            </Card>
            <Pagination
                jumpPage={true}
                initCall={false}
                count={true}
                component={InvoiceList.name}
                size={"sm"}
                paginationData={paginationData}
                nextPage={nextPage} />
        </FormLoader>
    )
}

export default InvoiceList;